import React from 'react';
import IconDocument from 'shared/icons/document';
import { IconDOC, IconPDF, IconPPT, IconXLS } from 'shared/icons/fileFormats';
import { IconProps } from 'shared/icons/iconProps';
import { each } from 'lodash-es';
import IconAI from 'shared/icons/fileFormats/ai';
import IconAE from 'shared/icons/fileFormats/ae';
import IconPSD from 'shared/icons/fileFormats/psd';
import IconJSON from 'shared/icons/fileFormats/json';
import IconMP4 from 'shared/icons/fileFormats/mp4';
import IconMov from 'shared/icons/fileFormats/mov';
import IconWebm from 'shared/icons/fileFormats/webm';
import IconBlend from 'shared/icons/fileFormats/blend';
import IconGltf from 'shared/icons/fileFormats/gltf';
import IconSvg from 'shared/icons/fileFormats/svg';
import IconPng from 'shared/icons/fileFormats/png';
import IconJpg from 'shared/icons/fileFormats/jpg';
import IconBin from 'shared/icons/fileFormats/bin';

const iconsMap = {
  pdf: IconPDF,
  doc: IconDOC,
  docx: IconDOC,
  ppt: IconPPT,
  xls: IconXLS,
  ai: IconAI,
  ae: IconAE,
  psd: IconPSD,
  json: IconJSON,
  geojson: IconJSON,
  mp4: IconMP4,
  mov: IconMov,
  webm: IconWebm,
  blend: IconBlend,
  gltf: IconGltf,
  svg: IconSvg,
  png: IconPng,
  jpg: IconJpg,
  jpeg: IconJpg,
  bin: IconBin,
};

export const unsorted = 'без папки';
export const unsortedFrontName = 'Несортированные';

export const previewFormats = ['PDF', 'DOC', 'DOCX', 'PPT', 'XLS'];
export const getFormatIcon = ({
  format,
  iconProps,
}: {
  format: string | null;
  iconProps?: IconProps;
}) => {
  if (!format) {
    return <IconDocument {...iconProps} name="?"></IconDocument>;
  }

  const Icon = iconsMap[format as keyof typeof iconsMap];

  if (!Icon) {
    return <IconDocument {...iconProps} name={format}></IconDocument>;
  }

  return <Icon {...iconProps}></Icon>;
};

export const makeTransition = (
  properties: string[],
  opt?: { foo?: string; duration?: '500ms' | '250ms' | '125ms' }
) => {
  let transition = '';

  const foo = opt?.foo || 'cubic-bezier(0.4, 0, 0.2, 1)';
  const dur = opt?.duration || '250ms';

  each(properties, (prop, i) => {
    transition += `${prop} ${foo} ${dur} 0ms${
      i === properties.length - 1 ? '' : ','
    }`;
  });

  return transition;
};

export const sizeToString = (size: number) => {
  const mb = size / 1024 / 1024;

  if (mb > 1) {
    return `${mb.toFixed(1)}MB`;
  }

  const kb = size / 1024;

  return `${kb.toFixed(1)}KB`;
};

export const noFormatName = 'Без формата';

export const getFormatNameFromFile = (filename: string) => {
  const splited = filename.split('.');

  if (splited.length === 1) {
    return null;
  }

  return getFormatName({ format: splited.slice(-1)[0] });
};

export const getFormatName = ({ format }: { format: string }) => {
  return format.toUpperCase();
};

export const isOdd = function (x: number) {
  return x & 1;
};
export const isEven = function (x: number) {
  return !(x & 1);
};
